const KEY_PREFIX = 'admin_pc_';

export default {
  // 首页路由名称
  HOME_PAGE: 'Home',
  // 登录页路由名称
  LOGIN_PAGE: 'Login',
  // 用户登录信息
  USER_INFO: `${KEY_PREFIX}user_info`,
  // nav-tags
  NAV_TAGS: `${KEY_PREFIX}nav_tags`,
};
